export enum WarmupDataKey {
  LocationParams = 'search:LocationParams',
  SamplesResponse = 'search:SamplesResponse',
  SearchResponse = 'search:SearchResponse',
  ProductsPriceFacetResponse = 'search:ProductsPriceFacetResponse',
  ProductsCollectionsFacetResponse = 'search:ProductsCollectionsFacetResponse',
  ForumContentTypeFacetResponse = 'search:ForumContentTypeFacetResponse',
  ForumCategoriesFacetResponse = 'search:ForumCategoriesFacetResponse',
}
